const path = process.env.REACT_APP_API_PATH;

export const api = {
    TEAMS_URL: path + "/teams",
    FIXTURES_URL: path + "/fixtures"
}